export default __webpack_public_path__ + "static/media/crmDesktop.9b013a05.jpg";